import { render, staticRenderFns } from "./Prolist.vue?vue&type=template&id=7285ce4c&"
import script from "./Prolist.vue?vue&type=script&lang=js&"
export * from "./Prolist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports